import { IconButton } from "@mui/material";
import styled from "styled-components";
import { LogoSVG } from "../../../assets/svg/Svgs";
import {
  APP_EMAIL,
  APP_NAME,
  APP_PHONE,
  EMAIL_URL,
  PHONE_URL,
} from "../../../constants/constants";
import {
  helpLinks,
  resourceLinks,
  socialLinks,
} from "../../../constants/links";
import { getCurrentYear } from "../../../utils/helperUtils";

export const Footer = () => {
  return (
    <>
      <GridWrapper className="container x100">
        <div>
          <img src={LogoSVG} height={40} alt={APP_NAME} />
          <div
            className="font10 grey"
            style={{
              marginTop: -10,
              marginLeft: 35,
            }}
          >
            by Lendtech Innovations
          </div>
        </div>

        {/* SECTIONS */}
        {/* <FooterSection links={helpLinks} title={"company"} /> */}
        <FooterSection links={resourceLinks} title={"resources"} />
        <FooterSection links={helpLinks} title={"help"} />

        {/* CONTACT */}
        <div className="flexColumn gap20">
          <div className="secondary bold font13 uppercase">Reach Out</div>

          <div>
            <div className="font11 grey semiBold mb5">CALL US</div>
            <a className="bold secondary" href={PHONE_URL}>
              {APP_PHONE}
            </a>
          </div>
          <div>
            <div className="font11 grey semiBold mb5">EMAIL US</div>
            <a className="bold secondary" href={EMAIL_URL}>
              {APP_EMAIL}
            </a>
          </div>
        </div>
      </GridWrapper>
      <Wrapper className="p20 container">
        <InnerWrapper className="flexSpaceCenter">
          <div>
            {/* COPYRIGHT */}
            <div className="grey font12 mb15">
              © Copyright {getCurrentYear()} - Lendtech Innovations Ltd. All
              Rights Reserved.
            </div>

            {/* COPYRIGHT 2*/}
            <div className="font10 grey">
              <a className="main semiBold" href="#home">
                Credtics.com
              </a>{" "}
              is a product of Lendtech Innovations Ltd.
              <br />
              Credtics.com and all associated technologies, features, and
              content are the exclusive property of Lendtech Innovations Ltd.
              Unauthorized use, reproduction, or distribution is strictly
              prohibited.
            </div>
          </div>
          <div className="flex">
            {socialLinks.map(({ icon: Icon, path }, i) => (
              <a href={path} key={i}>
                <IconButton>
                  <Icon fontSize="small" />
                </IconButton>
              </a>
            ))}
          </div>
        </InnerWrapper>
      </Wrapper>
    </>
  );
};

const FooterSection = ({ links, title }) => {
  return (
    <div className="flexColumn gap10 font13" id="footer">
      <div className="secondary bold mb15 uppercase">{title}</div>
      {links?.map(({ label, path, target }, i) => (
        <div className="grey" key={i}>
          <a href={path} className="grey" target={target}>
            {label}
          </a>
        </div>
      ))}
    </div>
  );
};

const GridWrapper = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  padding: 80px 20px;

  @media (max-width: 960px) {
    gap: 40px;
    grid-template-columns: 1fr;
    padding: 20px;
  }
`;
const Wrapper = styled.div`
  border-top: 1px solid #eee;
  padding-block: 30px;
`;
const InnerWrapper = styled.div`
  @media (max-width: 960px) {
    flex-direction: column;
    gap: 15px;
  }
`;
